/* Petifo - window.PetifoI18n.bundle.heading bundle + quick view.
   Loaded by snippets/pf-bundle.liquid. See that file for the design notes. */
(function () {
  if (window.__pfBundleReady) return;
  window.__pfBundleReady = true;

  function parseMoney(zero, big) {
    var numRe = /[0-9][0-9.,\u00A0\u202F ']*[0-9]|[0-9]/;
    var mz = zero.match(numRe);
    var mb = big.match(numRe);
    if (!mz || !mb) return null;
    var prefix = zero.slice(0, mz.index);
    var suffix = zero.slice(mz.index + mz[0].length);
    var decimals = 0, decSep = '';
    var dm = mz[0].match(/^0([.,])(\d{2})$/);
    if (dm) { decimals = 2; decSep = dm[1]; }
    var intPart = decimals ? mb[0].slice(0, mb[0].length - 3) : mb[0];
    var gm = intPart.match(/^1(\D)111/);
    var groupSep = gm ? gm[1] : '';
    return { prefix: prefix, suffix: suffix, decimals: decimals, decSep: decSep, groupSep: groupSep };
  }

  function makeFmt(cfg) {
    return function (cents) {
      if (!cfg) return String(Math.round(cents / 100));
      var intStr, decStr = '';
      if (cfg.decimals) {
        var fixed = (cents / 100).toFixed(2);
        intStr = fixed.slice(0, -3);
        decStr = cfg.decSep + fixed.slice(-2);
      } else {
        intStr = String(Math.round(cents / 100));
      }
      if (cfg.groupSep) intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, cfg.groupSep);
      return cfg.prefix + intStr + decStr + cfg.suffix;
    };
  }

  function init(root) {
    if (root.__pfInit) return;
    root.__pfInit = true;

    var disc = parseInt(root.dataset.discount, 10) || 0;
    var code = (root.dataset.code || '').trim();
    var fmt = makeFmt(parseMoney(root.dataset.moneyZero || '', root.dataset.moneyBig || ''));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-pf-item]'));
    var wasEl = root.querySelector('[data-pf-was]');
    var nowEl = root.querySelector('[data-pf-now]');
    var cta = root.querySelector('[data-pf-buy]');
    var errEl = root.querySelector('[data-pf-error]');
    var totalRight = root.querySelector('.pf-bundle__total-right');
    var tBadge = root.querySelector('[data-pf-tbadge]');
    var savingsEl = root.querySelector('[data-pf-savings]');
    var savingsAmount = root.querySelector('[data-pf-savings-amount]');
    var discountCopy = root.querySelectorAll('.pf-bundle__sub,.pf-bundle__pill,.pf-bundle__save');
    var appliedDisc = 0;
    var purchaseVersion = 0;
    var purchaseRequest;

    function resetPurchase() {
      purchaseVersion++;
      if (purchaseRequest) purchaseRequest.abort();
      purchaseRequest = null;
      root.classList.remove('is-loading');
      if (cta) cta.removeAttribute('aria-busy');
      if (errEl) errEl.hidden = true;
      recalc();
    }
    root.__pfRestorePurchase = resetPurchase;

    rows.forEach(function (row) {
      try { row.__variants = JSON.parse(row.dataset.pfVariants || '[]'); }
      catch (e) { row.__variants = []; }
    });

    function mainForm() {
      var scope = root.closest('.shopify-section') || document;
      return scope.querySelector('product-form-component[data-product-id="' + root.dataset.productId + '"]:not(.quick-add__product-form-component) form');
    }

    function mainVariantId() {
      var form = mainForm();
      var input = form && form.querySelector('input[name="id"]');
      var v = input && parseInt(input.value, 10);
      return v || null;
    }

    function selectedVariant(row) {
      var list = row.__variants || [];
      if (!list.length) return null;
      if (row.dataset.pfMain === 'true') {
        var id = mainVariantId();
        for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
        return list[0];
      }
      var sel = row.querySelector('[data-pf-select]');
      if (sel) {
        var sid = parseInt(sel.value, 10);
        for (var j = 0; j < list.length; j++) if (list[j].id === sid) return list[j];
      }
      for (var k = 0; k < list.length; k++) if (list[k].a) return list[k];
      return list[0];
    }

    function isOn(row) {
      if (row.dataset.pfMain === 'true') return true;
      var cb = row.querySelector('[data-pf-toggle]');
      return !cb || cb.checked;
    }

    /* The bundle price of one line.
         orig = the price it started at - the compare-at when the product is on
                sale, otherwise today's price.
         net  = what the customer actually pays here: today's price minus the
                bundle discount. Rounded PER LINE, because Shopify applies a
                percentage code per line too, so the bundle total matches what
                checkout charges instead of drifting by a cent.
         off  = the whole way down, orig -> net, which is what the shopper cares
                about. */
    function priceParts(v) {
      var base = v.p;
      var net = appliedDisc > 0 ? Math.round(base * (100 - appliedDisc) / 100) : base;
      var orig = (v.c && v.c > base) ? v.c : base;
      return {
        orig: orig,
        net: net,
        off: orig > net ? Math.round((orig - net) * 100 / orig) : 0
      };
    }

    function renderRow(row, v) {
      var priceEl = row.querySelector('[data-pf-price]');
      if (!priceEl || !v) return;
      var pp = priceParts(v);
      /* The -X% pill sits in the PRICE column on the right, on the same line as
         the struck price - not on the thumbnail. On a 52px thumb it covered the
         product and was half clipped by the thumb's overflow:hidden. Next to the
         price it also reads as what it is: how far this line came down. */
      var html = '';
      if (pp.orig > pp.net) {
        html += '<span class="pf-row-top">';
        if (pp.off > 0) html += '<span class="pf-row-off">-' + pp.off + '%</span>';
        html += '<span class="pf-row-was">' + fmt(pp.orig) + '</span>';
        html += '</span>';
      }
      html += '<span class="pf-row-now">' + fmt(pp.net) + '</span>';
      priceEl.innerHTML = html;
      priceEl.classList.toggle('is-off', pp.off > 0);
      var label = row.querySelector('[data-pf-variant-label]');
      if (label) label.textContent = (v.t && v.t !== 'Default Title') ? v.t : '';
    }

    function recalc() {
      // PETIFOSET5 requires at least two items. A main product alone keeps only
      // its own sale saving; never include an ineligible extra bundle discount.
      var selectedCount = rows.filter(function (row) {
        var v = selectedVariant(row);
        return isOn(row) && v && v.a;
      }).length;
      appliedDisc = code && selectedCount >= 2 ? disc : 0;
      discountCopy.forEach(function (el) { el.hidden = appliedDisc <= 0; });
      var net = 0, compare = 0, available = true;
      rows.forEach(function (row) {
        var v = selectedVariant(row);
        renderRow(row, v);
        var on = isOn(row);
        row.classList.toggle('pf-bundle__row--unchecked', !on);
        if (!on || !v) return;
        var pp = priceParts(v);
        net += pp.net;
        compare += pp.orig;
        if (row.dataset.pfMain === 'true' && !v.a) available = false;
      });
      var saving = compare > net;
      if (wasEl) wasEl.textContent = saving ? fmt(compare) : '';
      if (nowEl) nowEl.textContent = fmt(net);
      if (savingsAmount) savingsAmount.textContent = saving ? fmt(compare - net) : '';
      if (savingsEl) savingsEl.hidden = !saving;
      if (totalRight) totalRight.classList.toggle('is-off', saving);
      /* Total badge: the whole saving against the compare-at sum, so it also
         covers the bundle discount, not only the per-product sale. */
      if (tBadge) {
        if (saving && compare > 0) {
          tBadge.textContent = '-' + Math.round((compare - net) * 100 / compare) + '%';
          tBadge.hidden = false;
        } else {
          tBadge.textContent = '';
          tBadge.hidden = true;
        }
      }
      if (cta) cta.disabled = !available || root.classList.contains('is-loading');
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-pf-toggle],[data-pf-select]')) recalc();
    });

    var lastMain = mainVariantId();
    setInterval(function () {
      var now = mainVariantId();
      if (now !== lastMain) { lastMain = now; recalc(); }
    }, 600);

    if (cta) {
      cta.addEventListener('click', function () {
        if (root.classList.contains('is-loading')) return;
        var form = mainForm();
        if (!form) return;
        if (!form.reportValidity()) return;
        var properties = {};
        new FormData(form).forEach(function (value, name) {
          if (/^properties\[.+\]$/.test(name) && typeof value === 'string') properties[name.slice(11, -1)] = value;
        });
        var items = [];
        rows.forEach(function (row) {
          if (!isOn(row)) return;
          var v = selectedVariant(row);
          if (v && v.a) {
            var item = { id: v.id, quantity: 1 };
            if (row.dataset.pfMain === 'true') item.properties = properties;
            items.push(item);
          }
        });
        if (!items.length) return;
        var version = ++purchaseVersion;
        purchaseRequest = new AbortController();
        root.classList.add('is-loading');
        cta.disabled = true;
        cta.setAttribute('aria-busy', 'true');
        if (errEl) errEl.hidden = true;
        var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          signal: purchaseRequest.signal,
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          if (version !== purchaseVersion) return;
          purchaseRequest = null;
          window.location.href = code && disc > 0 && items.length >= 2
            ? routeRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routeRoot + 'checkout')
            : routeRoot + 'checkout';
        }).catch(function (error) {
          if (version !== purchaseVersion || error.name === 'AbortError') return;
          resetPurchase();
          if (errEl) { errEl.hidden = false; errEl.textContent = window.PetifoI18n.bundle.error; }
        });
      });
    }

    /* ---------- quick view ---------- */
    var qv = root.querySelector('[data-pf-qv]');
    var qvBody = root.querySelector('[data-pf-qv-body]');
    var qvCta = root.dataset.qvCta || window.PetifoI18n.bundle.view_details;
    var cache = {};
    var qvRequest = 0;
    var qvTrigger;
    var qvOverflow;

    function closeQv() {
      if (!qv) return;
      qvRequest++;
      if (qv.open) qv.close();
      qv.hidden = true;
      document.documentElement.style.overflow = qvOverflow || '';
      if (qvTrigger && qvTrigger.isConnected) qvTrigger.focus({ preventScroll: true });
    }

    function sized(src, w) {
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function paintQv(productUrl, data, v) {
      var imgs = (data.images || []).slice(0, 6).map(function (src) {
        return '<img src="' + sized(src, 400) + '" alt="" loading="lazy">';
      }).join('');
      var net = v ? v.p : 0;
      var was = (v && v.c && v.c > v.p) ? '<span class="pf-qv-was">' + fmt(v.c) + '</span>' : '';
      var html = '';
      if (imgs) html += '<div class="pf-qv__media">' + imgs + '</div>';
      html += '<h3 class="pf-qv__title"></h3>';
      if (v) html += '<div class="pf-qv__price"><span class="pf-qv-now">' + fmt(net) + '</span>' + was + '</div>';
      if (data.delivery) html += '<div class="pf-qv__delivery">' + data.delivery + '</div>';
      html += '<div class="pf-qv__desc">' + (data.description || '') + '</div>';
      html += '<a class="pf-qv__link"></a>';
      qvBody.innerHTML = html;
      qvBody.querySelector('.pf-qv__title').textContent = data.title || '';
      qvBody.querySelector('.pf-qv__link').textContent = qvCta;
      qvBody.querySelector('.pf-qv__link').href = productUrl;
      qvBody.scrollTop = 0;
    }

    function openQv(row, v, trigger) {
      if (!qv || !qvBody) return;
      var productUrl = new URL(row.dataset.pfUrl, window.location.origin);
      if (v) productUrl.searchParams.set('variant', v.id);
      var cacheKey = productUrl.href;
      var request = ++qvRequest;
      qvTrigger = trigger;
      if (qv.hidden) qvOverflow = document.documentElement.style.overflow;
      qv.hidden = false;
      qv.setAttribute('aria-label', row.querySelector('.pf-bundle__name').textContent.trim());
      if (!qv.open) qv.showModal();
      document.documentElement.style.overflow = 'hidden';
      qv.querySelector('.pf-qv__close').focus({ preventScroll: true });
      if (cache[cacheKey]) { paintQv(cacheKey, cache[cacheKey], v); return; }
      qvBody.innerHTML = '<div class="pf-qv__loading" aria-busy="true">...</div>';
      var jsonUrl = new URL(productUrl);
      jsonUrl.pathname += '.js';
      // Read the chosen product's own server-rendered delivery row. This keeps
      // its template settings, dynamic sources, variant and translations intact.
      Promise.all([
        fetch(jsonUrl.href, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); }),
        fetch(cacheKey, { headers: { 'Accept': 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error('delivery'); return r.text(); })
      ]).then(function (results) {
        var data = results[0];
        var page = new DOMParser().parseFromString(results[1], 'text/html');
        var delivery = Array.prototype.find.call(page.querySelectorAll('product-form-component .pdp-delivery-estimate'), function (el) {
          return !el.closest('sticky-add-to-cart,.sticky-add-to-cart');
        });
        data.delivery = delivery ? delivery.outerHTML : '';
        cache[cacheKey] = data;
        if (request === qvRequest && !qv.hidden) paintQv(cacheKey, data, v);
      }).catch(function () {
        if (request !== qvRequest || qv.hidden) return;
        qvBody.innerHTML = '<div class="pf-qv__loading"></div><a class="pf-qv__link"></a>';
        qvBody.querySelector('.pf-qv__loading').textContent = window.PetifoI18n.bundle.error;
        var link = qvBody.querySelector('.pf-qv__link');
        link.textContent = qvCta;
        link.href = cacheKey;
      });
    }

    if (qv) qv.addEventListener('cancel', function (e) { e.preventDefault(); closeQv(); });

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-pf-quick]');
      if (trigger) {
        var row = trigger.closest('[data-pf-item]');
        if (row && row.dataset.pfHandle) { e.preventDefault(); openQv(row, selectedVariant(row), trigger); }
        return;
      }
      if (e.target.closest('[data-pf-qv-close]')) { e.preventDefault(); closeQv(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && qv && !qv.hidden) closeQv();
    });

    recalc();
  }

  function boot() {
    document.querySelectorAll('[data-pf-bundle]').forEach(function (el) {
      if (el.closest('sticky-add-to-cart,.sticky-add-to-cart')) return;
      init(el);
    });
  }

  // The browser restores the existing DOM after checkout; DOMContentLoaded
  // does not run again for a back/forward-cache restoration.
  function restorePurchases() {
    document.querySelectorAll('[data-pf-bundle]').forEach(function (root) {
      if (root.__pfRestorePurchase) root.__pfRestorePurchase();
    });
  }
  window.addEventListener('pagehide', restorePurchases);
  window.addEventListener('pageshow', function () {
    boot();
    restorePurchases();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
